import { render } from "./product-addon-lens.vue?vue&type=template&id=9c377bee&scoped=true&lang=pug"
import script from "./product-addon-lens.vue?vue&type=script&lang=js"
export * from "./product-addon-lens.vue?vue&type=script&lang=js"

import "./product-addon-lens.vue?vue&type=style&index=0&id=9c377bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c377bee"]])

export default __exports__